import { render, staticRenderFns } from "./cash-collection-by-cashier-summary.vue?vue&type=template&id=83dc18b0&scoped=true&"
import script from "./cash-collection-by-cashier-summary.vue?vue&type=script&lang=js&"
export * from "./cash-collection-by-cashier-summary.vue?vue&type=script&lang=js&"
import style0 from "./cash-collection-by-cashier-summary.vue?vue&type=style&index=0&id=83dc18b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dc18b0",
  null
  
)

export default component.exports